import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

const Dato = ({styles, elemento}) => {
  return(
    <p style={styles.elemLis_1}>{elemento.codigoCiudad} ={">"} {elemento.nombreCiudad}</p>
  )};

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return (
    <div className="ui middle aligned animated celled link list" style={styles.listaDer}>
      <div className="item">
        <List.Item onClick={(ev)=>handleClickidLista(ev, elemento)}>
            <List.Header>
                <div className="floated content" style={styles.subElemLis_1}>
                    <a className="header"><Dato styles={styles} elemento={elemento}/></a>
                </div>
            </List.Header>
        </List.Item>
      </div>
    </div>
  )
};

const Lista = ({styles, list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 styles={styles} handleClickidLista={handleClickidLista} elemento={elemento} key={i} />);
  return(
    <div>
      {nivel1Detalle}
    </div>
  )
};

const DirCiu2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const listCiu = []
  list.forEach((elemento, _id) => {
    if(elemento.ciudades.length>0){
      elemento.ciudades.forEach((elemento1, i) => {
        listCiu.push({_id: elemento._id, codigoDpto: elemento.codigoDpto,
          descrDpto: elemento.descrDpto, codigoCiudad: elemento1.codigoCiudad,
          nombreCiudad: elemento1.nombreCiudad, codigoMunicipioDANE: elemento1.codigoMunicipioDANE,
          codigoPostalDANE: elemento1.codigoPostalDANE, codigoCiudadInterno: elemento1.codigoCiudadInterno,
          codBarrasRdo: elemento1.codBarrasRdo?elemento1.codBarrasRdo:""})
      })
    }
  })

    function ordenarAsc(array, campo) {
        array.sort(function (a, b) {
           return a[campo] > b[campo];
        });
     }
     ordenarAsc(listCiu, 'codigoCiudad')

     const a01050501 = autorizacUA.findIndex( autorizac => autorizac === "01050501" );

    return (
    <div>
      <List selection>
      <TitDer list={listCiu} textBoton1="Ciudades" btnNuevo={a01050501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />

      <Lista list={listCiu} styles={styles} handleClickidLista={handleClickidLista}/>
      </List>
    </div>
  )
};

export default DirCiu2
